import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, switchMap, throwError } from 'rxjs';
import { TokenRefreshService } from '@services/token-refresh.service';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutes } from '@helpers/app-routes';

export const tokenRefreshInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenRefresh = inject(TokenRefreshService);
  const router = inject(Router);
  const toast = inject(ToastrService);
  const translate = inject(TranslateService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        return throwError(() => error);
      }

      return tokenRefresh.refreshAccessToken().pipe(
        switchMap((newToken) => {
          const retried = req.clone({
            setHeaders: { Authorization: `Bearer ${newToken}` },
          });
          return next(retried);
        }),
        catchError(() => {
          tokenRefresh.clearTokens();
          toast.error(
            translate.instant('session.errors.expired_title'),
            translate.instant('session.errors.expired_message'),
          );
          void router.navigate([AppRoutes.login], { replaceUrl: true });
          return throwError(() => error);
        }),
      );
    }),
  );
};
